import { render, staticRenderFns } from "./OngoingApplications.vue?vue&type=template&id=5f092efa&"
import script from "./OngoingApplications.vue?vue&type=script&lang=js&"
export * from "./OngoingApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports